import React from "react";
import useShowLoader from "../../common/loading-widgets/useShowLoader.js";
import SponsoredRecruiterSearchResult from "../search/SponsoredRecruiterSearchResult.js";
import useQuerySponsoredRecruiterWithHireCountSearch from "../search/useQuerySponsoredRecruiterWithHireCountSearch.js";
import RecruiterSortEnum from "../RecruiterSortEnum.js";
import useTranslationSponsorship from "../useTranslationSponsorship.js";
import LastViewedList from "../../common/components/LastViewedList.js";

const LIST_LENGTH = 50;

export default function SponsoredRecruiterList(props) {
  const { recruiterId } = props;

  const { data, loading, errors } = useQuerySponsoredRecruiterWithHireCountSearch(
    recruiterId,
    0,
    LIST_LENGTH,
    { },
    RecruiterSortEnum.CREATED_AT_DESC
  );

  const { t, loading: tLoading } = useTranslationSponsorship();
  useShowLoader(tLoading, "SponsoredRecruiterList");

  const emptyMsg = t("sponsorship:sponsored_search_empty_msg");
  const getItemId = (candidate) => candidate._id;

  return (
    <div className="SponsoredRecruiterList">
      <LastViewedList
        items={data ? data.nodes : []}
        loading={loading}
        errors={errors}
        className={"SponsoredRecruiterList"}
        emptyMsg={emptyMsg}
        getItemId={getItemId}
        SearchResult={<SponsoredRecruiterSearchResult />}
      />
    </div>
  );
}
